import React, { useEffect } from "react";
import { Router, Route, Switch } from "react-router-dom";
import PrivateRoute from "./Dashboard/layout/PrivateRoute";
import Login from "./Login/Login";
import RedirectToWrapper from "./RedirectToWrapper/RedirectToWrapper";
import Dashboard from "./Dashboard/layout/index";
import NotFound from "./NotFound/NotFound";
import { Provider } from "react-redux";
import store from "./store";
import { loadUser } from "./Dashboard/actions/auth";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import ModalsListener from "./Dashboard/components/ModalsListener/ModalsListener";
import ScrollToTop from "./Dashboard/components/ScrollToTop/ScrollToTop";
import "ag-grid-enterprise";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import hist from "./hist";

export const App = () => {
  useEffect(() => {
    store.dispatch(loadUser());
    document.title = "RES";
  }, []);

  return (
    <Provider store={store}>
      <ModalsListener></ModalsListener>
      <Router history={hist}>
        <div className="App">
          <ScrollToTop />
          <Switch>
            {/* <Route exact path="/" component={Login}></Route> */}
            <Route exact path="/" component={RedirectToWrapper}></Route>
            <PrivateRoute
              path="/dashboard"
              component={Dashboard}
            ></PrivateRoute>
            <Route component={NotFound}></Route>
          </Switch>
        </div>
      </Router>
    </Provider>
  );
};

export default App;
